import gql from "graphql-tag";

export const POINT_CAMPAIGN_EVENT_CREATE = gql`
  mutation pointCampaignEventCreate($input: PointCampaignEventInput!) {
    pointCampaignEventCreate(input: $input) {
      errors {
        field
        message
      }
      pointCampaignEvent {
        id
      }
    }
  }
`;

export const POINT_CAMPAIGN = gql`
  query pointCampaign($id: ID!) {
    pointCampaignAvailabilityCheck(id: $id)
    pointCampaignEarnPointSum(id: $id)
    me {
      id
      point {
        id
        availableAmount
      }
    }
  }
`;


